export default {
  dailyCovers: state => state.dailyCovers,
  dailyCoverInfos: state => state.dailyCoverInfos,
  totalPages: state => state.totalPages
}
